export default __webpack_public_path__ + "static/media/BREAKOUT.339d5f22.svg";